export enum ActionTypeEnum {
    Assigned = 'Assigned',
    Reassigned = 'Reassigned',
    Unassigned = 'Unassigned',
    Started = 'Started',
    Paused = 'Paused',
    Completed = 'Completed',
    Reopened = 'Reopened',
    AutoCompleted = 'AutoCompleted',
    SubmittedForApproval = 'SubmittedForApproval',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Reviewed = 'Reviewed',
    Escalated = 'Escalated',
    DriverAssigned = 'DriverAssigned',
    DriverChanged = 'DriverChanged',
    PickupScheduled = 'PickupScheduled',
    PickupCompleted = 'PickupCompleted',
    SubmissionCompleted = 'SubmissionCompleted',
    DocumentRejected = 'DocumentRejected',
    ResubmissionScheduled = 'ResubmissionScheduled',
    Commented = 'Commented',
    CustomerContacted = 'CustomerContacted',
    CustomerUnreachable = 'CustomerUnreachable',
    MeetingScheduled = 'MeetingScheduled',
    CallBackRequested = 'CallBackRequested',
    FileUploaded = 'FileUploaded',
    FileRemoved = 'FileRemoved',
    DocVerified = 'DocVerified',
    DocRejected = 'DocRejected',
    DeadlineExtended = 'DeadlineExtended',
    DeadlineMissed = 'DeadlineMissed',
    Rescheduled = 'Rescheduled',
    NotificationSent = 'NotificationSent',
    ReminderSent = 'ReminderSent',
    StatusChanged = 'StatusChanged',
    AutoReminderTriggered = 'AutoReminderTriggered',
    ErrorFlagged = 'ErrorFlagged',
    ManualOverride = 'ManualOverride',
  }
   